import type { CrmDealDto } from '@upme/contracts';
import type { CrmRoleActivityStatus } from './role-display';

/** Бот заблокировал чат — рассылки недоступны. */
export function isBotBlocked(contact: Pick<CrmDealDto['contact'], 'botBlockedAt'>): boolean {
  return contact.botBlockedAt != null;
}

/** Start в боте ещё не нажат (аккаунт может существовать). */
export function isBotNotStarted(
  contact: Pick<CrmDealDto['contact'], 'botStartedAt' | 'botBlockedAt'>,
): boolean {
  return !contact.botBlockedAt && contact.botStartedAt == null;
}

/**
 * Участник Active — по текущим правилам Connection Card: прошедшие EVENT|MEETING с CONFIRMED.
 * (QR CHECKED_IN на билете — отдельный инвариант, см. gaps CRM.)
 */
export function isParticipantActive(contact: Pick<CrmDealDto['contact'], 'meetingsCount'>): boolean {
  return contact.meetingsCount > 0;
}

/**
 * Организатор Active — прошлый EVENT с QR check-in (Ticket CHECKED_IN) или групповым фото с тегами.
 * Счётчик приходит с бэка (`organizedEventsWithVerifiedAttendance`).
 */
export function isOrganizerActive(
  contact: Pick<CrmDealDto['contact'], 'organizedEventsWithVerifiedAttendance'>,
): boolean {
  return contact.organizedEventsWithVerifiedAttendance > 0;
}

export function resolveParticipantRoleStatus(
  contact: Pick<CrmDealDto['contact'], 'meetingsCount' | 'botStartedAt' | 'botBlockedAt'>,
): CrmRoleActivityStatus {
  if (isBotBlocked(contact)) return 'outside';
  if (isParticipantActive(contact)) return 'active';
  return 'guest';
}

export function resolveOrganizerRoleStatus(
  contact: Pick<
    CrmDealDto['contact'],
    'organizedEventsWithVerifiedAttendance' | 'botStartedAt' | 'botBlockedAt'
  >,
): CrmRoleActivityStatus {
  if (isBotBlocked(contact)) return 'outside';
  if (isOrganizerActive(contact)) return 'active';
  return 'guest';
}
